// extracted by mini-css-extract-plugin
module.exports = {"expenses":"Expenses_expenses__1PgVu"};